// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset some default spacing */
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body, html {
    height: 100%;
    font-family: Arial, sans-serif;
    background-color: #f8f9fa;
}

/* Layout container */
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

/* Card box */
.login-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    height: 500px;
    padding: 2rem;
    width: 100%;
    max-width: 400px;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.subtitle {
    text-align: center;
    font-size: 16px;
    color: #6b7280;
    margin-bottom: 24px;
}


/* Logo styling */
.logo-container {
    text-align: center;
    margin-bottom: 1.5rem;
    color: #0a1e40;
    font-weight: 700;
    font-size: 24px;

}

.logo {
    max-width: 45px;
    margin-bottom: -10px;
}

/* Form elements */
.form-group {
    margin-bottom: 1rem;
}

form {
    width: 100%;
}

.form-group label {
    font-family: Arial, sans-serif;
    font-size: 16px;
    color: #6b7280;
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.form-group input {
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
}

/* Password wrapper with eye icon */
.password-input-wrapper {
    position: relative;
}

.password-input-wrapper input {
    width: 100%;
    padding-right: 2.5rem;
}

.toggle-password {
    position: absolute;
    top: 50%;
    right: 0.75rem;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
}

/* Error message */
.form-error {
    color: #dc3545;
    font-size: 0.9rem;
    margin-bottom: 1rem;
}

/* Button */
.login-button {
    width: 100%;
    padding: 0.75rem;
    background-color: #007bff;
    color: white;
    font-size: 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.login-button:hover {
    background-color: #0056b3;
}

.forgot-password {
    text-align: center;
    margin-top: 20px;
}

.forgot-password a {
    color: #4b5563;
    font-size: 14px;
    text-decoration: none;
}

.forgot-password a:hover {
    text-decoration: underline;
}

label {

    font-size: 16px;
    color: #0a1e40;
}

h2 {
    text-align: center;
    font-size: 24px;
    margin-bottom: 8px;
    color: #0a1e40;
}

.form-group label,
.form-group input,
.password-input-wrapper {
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/Auth/LoginForm.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,aAAa;AACb;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;;AAGA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;AAEA,kBAAkB;AAClB;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;;IAGI,gBAAgB;AACpB","sourcesContent":["/* Reset some default spacing */\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\nbody, html {\n    height: 100%;\n    font-family: Arial, sans-serif;\n    background-color: #f8f9fa;\n}\n\n/* Layout container */\n.login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n}\n\n/* Card box */\n.login-card {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: white;\n    height: 500px;\n    padding: 2rem;\n    width: 100%;\n    max-width: 400px;\n    border-radius: 8px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n    text-align: center;\n}\n\n.subtitle {\n    text-align: center;\n    font-size: 16px;\n    color: #6b7280;\n    margin-bottom: 24px;\n}\n\n\n/* Logo styling */\n.logo-container {\n    text-align: center;\n    margin-bottom: 1.5rem;\n    color: #0a1e40;\n    font-weight: 700;\n    font-size: 24px;\n\n}\n\n.logo {\n    max-width: 45px;\n    margin-bottom: -10px;\n}\n\n/* Form elements */\n.form-group {\n    margin-bottom: 1rem;\n}\n\nform {\n    width: 100%;\n}\n\n.form-group label {\n    font-family: Arial, sans-serif;\n    font-size: 16px;\n    color: #6b7280;\n    display: block;\n    margin-bottom: 0.5rem;\n    font-weight: 600;\n}\n\n.form-group input {\n    width: 100%;\n    padding: 0.5rem;\n    font-size: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n/* Password wrapper with eye icon */\n.password-input-wrapper {\n    position: relative;\n}\n\n.password-input-wrapper input {\n    width: 100%;\n    padding-right: 2.5rem;\n}\n\n.toggle-password {\n    position: absolute;\n    top: 50%;\n    right: 0.75rem;\n    transform: translateY(-50%);\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n}\n\n/* Error message */\n.form-error {\n    color: #dc3545;\n    font-size: 0.9rem;\n    margin-bottom: 1rem;\n}\n\n/* Button */\n.login-button {\n    width: 100%;\n    padding: 0.75rem;\n    background-color: #007bff;\n    color: white;\n    font-size: 1rem;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.login-button:hover {\n    background-color: #0056b3;\n}\n\n.forgot-password {\n    text-align: center;\n    margin-top: 20px;\n}\n\n.forgot-password a {\n    color: #4b5563;\n    font-size: 14px;\n    text-decoration: none;\n}\n\n.forgot-password a:hover {\n    text-decoration: underline;\n}\n\nlabel {\n\n    font-size: 16px;\n    color: #0a1e40;\n}\n\nh2 {\n    text-align: center;\n    font-size: 24px;\n    margin-bottom: 8px;\n    color: #0a1e40;\n}\n\n.form-group label,\n.form-group input,\n.password-input-wrapper {\n    text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
